var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.856 8C15.856 12.4183 12.3065 16 7.92801 16C3.54949 16 0 12.4183 0 8C0 3.58172 3.54949 0 7.92801 0C12.3065 0 15.856 3.58172 15.856 8ZM11.9221 4.96967C11.6318 4.67678 11.1612 4.67678 10.8709 4.96967C10.8639 4.97674 10.8574 4.98424 10.8512 4.9921L7.41011 9.41674L5.33543 7.32322C5.04517 7.03033 4.57457 7.03033 4.28431 7.32322C3.99405 7.61612 3.99405 8.09099 4.28431 8.38388L6.90694 11.0303C7.1972 11.3232 7.6678 11.3232 7.95806 11.0303C7.96452 11.0238 7.97062 11.0169 7.97633 11.0097L11.9326 6.01947C12.2123 5.72582 12.2088 5.25897 11.9221 4.96967Z",
    fill: "#5C5E69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoTick);
export default __webpack_public_path__ + "static/media/info-tick.8eb237751137ffe4eb89b9a71c612b26.svg";
export { ForwardRef as ReactComponent };